import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../services/store";

export interface OperationHour {
  fromDay: string;
  fromHour: string;
  fromPeriod: string;
  toDay: string;
  toHour: string;
  toPeriod: string;
}

export interface ProfileState {
  company_id: string;
  profile: string | null;

  // individual fields
  first_name: string;
  last_name: string | null;
  phone: string | null;

  // company fields
  company_name: string | null;
  company_email: string | null;
  support_email: string | null;
  company_address: string | null;
  company_phone: string | null;
  company_type: string | null;
  company_logo: File | string | null;

  // extra company info
  about_description: string | null;
  business_zone: string | null;
  has_other_branch: boolean | null;

  // location
  country_id: number | string | null;
  state_id: number | string | null;

  // operation hours 
  operation_hours: OperationHour[] | null;

  // kyc
  document_type_name: string | null;
  document_type_description: string | null;
  business_reg_no: string | null;
  tax_no: string | null;

  // services
  service_ids: string[] | null;
}

const initialState: ProfileState = {
  company_id: "",
  profile: null,

  // individual
  first_name: "",
  last_name: null,
  phone: null,

  // company
  company_name: null,
  company_email: null,
  support_email: null,
  company_address: null,
  company_phone: null,
  company_type: null,
  company_logo: null,

  // extra
  about_description: null,
  business_zone: null,
  has_other_branch: false,

  // location
  country_id: null,
  state_id: null,

  // hours
  operation_hours: [],

  // kyc
  document_type_name: null,
  document_type_description: null,
  business_reg_no: null,
  tax_no: null,

  // services
  service_ids: null,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfileField: <K extends keyof ProfileState>(
      state: ProfileState,
      action: PayloadAction<{ field: K; value: ProfileState[K] }>
    ) => {
      state[action.payload.field] = action.payload.value;
    },
    resetProfile: () => initialState,
  },
});

export const { setProfileField, resetProfile } = profileSlice.actions;

export const selectProfile = (state: RootState) => state.profile;

export const profileSliceReducer = profileSlice.reducer;
